import { useGoodTableContext } from './table-context';
import { TableSliderComponent } from './table-slider-component/table-slider-component';
export const GoodTableSlider = () => {
    const { scrollPosition, outerWidth, scrollWidth, overflowX, scrollTo } = useGoodTableContext();
    const percentage = overflowX === 0 ? 0 : scrollPosition.x / overflowX;
    const visiblePercentage = outerWidth / scrollWidth;
    return (<TableSliderComponent value={percentage} onChange={(value) => {
            const position = value * overflowX;
            scrollTo(position);
        }} visiblePercentage={visiblePercentage}/>);
};
